module.exports = __webpack_public_path__ + "img/QS.0b94433f.png";